import { defineStore } from "pinia";
import defaultBranding from "@/branding/defaultBranding";
import { applyBrandingToDocument, resolveBranding } from "@/utils/branding";

const isBrowser = typeof window !== "undefined";

export const useBrandingStore = defineStore("branding", {
  state: () => ({
    branding: defaultBranding,
    isLoaded: false,
    hasCustomBranding: false,
  }),
  actions: {
    async loadBranding() {
      let overrides = null;

      if (isBrowser && window.__BRANDING__) {
        overrides = window.__BRANDING__;
      } else if (isBrowser) {
        try {
          const response = await fetch(
            import.meta.env.BASE_URL + "branding.json",
            {
              cache: "no-store",
            },
          );
          if (response.ok) {
            overrides = await response.json();
          }
        } catch (error) {
          // Ignore missing branding overrides
        }
      }

      this.hasCustomBranding = !!overrides;
      this.branding = resolveBranding(overrides || {});
      applyBrandingToDocument(this.branding);
      this.isLoaded = true;
    },
    setBranding(branding) {
      this.hasCustomBranding = !!branding;
      this.branding = resolveBranding(branding || {});
      applyBrandingToDocument(this.branding);
      this.isLoaded = true;
    },
  },
});
